module.exports = require("@angular-architects/native-federation");